import { addToast } from '@octano/global-ui';
import { useParams } from 'react-router';
import { Card, Col, Row } from 'reactstrap';
import GoBackButton from '../../../../components/buttons/GoBackButton';
import { useActionKitImp } from '../../../../components/ozmoit/common';
import { SessionFormLoader } from '../create/hooks/SessionFormLoader';
import { updateSessionAction } from './actions';
import { SessionViewLoader } from './hooks/SessionViewLoader';
import useTexts from './hooks/useTexts';
import { FormUpdate } from './parts/FormUpdate';

export function ContainerUpdateCeia() {
  const params = useParams<{ id: string }>();
  const texts = useTexts();

  const { action: handleOnSumbit, loading } = useActionKitImp(
    updateSessionAction,
    {
      onSuccess: () => {
        addToast({
          icon: 'success',
          color: 'success',
          text: texts.msg.success,
        });
        // history.push(`${PathsLayouts.studentWarnings}/?tab=risk-evaluation`);
      },
      onError: {
        unknown: () => {
          addToast({
            icon: 'error',
            color: 'danger',
            text: texts.msg.error,
          });
        },
      },
    },
  );

  return (
    <div className="mx-3">
      <Card className="p-4 mt-2 mx-3">
        <SessionFormLoader fetchImmediately>
          <SessionViewLoader
            defaultQuery={{
              ...params,
            }}
            fetchImmediately
          >
            <Row>
              <Col xs={12} lg={6} className="mb-2">
                <GoBackButton text={texts.backToList} />
              </Col>
              <Col md={12} className="mb-4">
                <h2 className="text-primary fs-20 fw-700 mt-4 mb-2 text-uppercase">
                  {texts.title}
                </h2>
              </Col>
              <FormUpdate handleOnSumbit={handleOnSumbit} loading={loading} />
            </Row>
          </SessionViewLoader>
        </SessionFormLoader>
      </Card>
    </div>
  );
}
